module.exports = __webpack_public_path__ + "assets/media/iPhone-13-desk.ab9b7d18.jpg";